<pfx-multi-select
  class="w-full"
  [label]="label | i18next: { ns: i18nNamespace() }"
  [options]="languageOptions"
  [i18nNamespace]="i18nNamespace()"
></pfx-multi-select>
